"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crumb = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var Typography_1 = __importDefault(require("../Typography"));
var Icon_1 = __importDefault(require("../Icon"));
var react_2 = require("@emotion/react");
var getCSSRules = function (theme, props) { return ({
    label: {
        cursor: props.onClick ? 'pointer' : 'default',
    },
    arrow: {
        margin: "0 ".concat(theme.margins.sm, "px"),
    },
}); };
var Crumb = function (props) {
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme, props);
    var children = props.children, active = props.active, completed = props.completed, withArrow = props.withArrow, className = props.className, color = props.color, rest = __rest(props, ["children", "active", "completed", "withArrow", "className", "color"]);
    var statusColor = (0, react_1.useMemo)(function () {
        if (color)
            return color;
        return active ? 'Grey@900' : completed ? 'Green@600' : 'Grey@500';
    }, [active, completed]);
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var css = _a.css;
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ uppercase: true, variant: 'textSmall', color: statusColor, weight: 'bold', css: styles.label, className: className }, rest, { children: children }), void 0), withArrow && ((0, jsx_runtime_1.jsx)(Icon_1.default, { name: 'arrowForward', size: 'sm', color: statusColor, className: css(styles.arrow) }, void 0))] }, void 0));
        } }, void 0));
};
exports.Crumb = Crumb;
//# sourceMappingURL=Crumb.js.map